// $(document).ready(function() {
//   var $slider = $('.custom_slider');
//   var $progressBar = $('.progress');
//   var $progressBarLabel = $( '.slider__label' );
  
//   $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
//     var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
//     $progressBar
//       .css('background-size', calc + '% 100%')
//       .attr('aria-valuenow', calc );
    
//     $progressBarLabel.text( calc + '% completed' );
//   });
  
//   $slider.slick({
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     speed: 400,
//     infinite: true,
//     arrows: true,
//     prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
//     nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
//         responsive: [
//         {
//         breakpoint: 1024,
//         settings: {
//             slidesToShow: 3,
//             slidesToScroll: 3
//         }
//         },
//         {
//         breakpoint: 600,
//         settings: {
//             slidesToShow: 2,
//             slidesToScroll: 2
//         }
//         },
//         {
//         breakpoint: 480,
//         settings: {
//             slidesToShow: 1,
//             slidesToScroll: 1
//         }
//         }
//     ]
//   });
  
//   var isDragging = false;

//   $(".progress").on("mousedown touchstart", function(e) {
//       isDragging = true;
//       updateProgress(e);
//   });

//   $(document).on("mousemove touchmove", function(e) {
//       if (isDragging) {
//           updateProgress(e);
//       }
//   });

//   $(document).on("mouseup touchend", function() {
//       isDragging = false;
//   });

//   function updateProgress(e) {
//       var progress = $(".progress");
//       var width = progress.width();
//       var offset = progress.offset().left;

//       var x = (e.pageX || e.originalEvent.touches[0].pageX) - offset;
//       if (x < 0) x = 0;
//       if (x > width) x = width;

//       var percent = (x / width) * 100;
//       $(".progress-handle").css("width", percent + "%");

      
//       var slickIndex = Math.round((percent / 100) * ($(".custom_slider").slick("getSlick").slideCount - 1));

//       $(".custom_slider").slick("slickGoTo", slickIndex, false);
//   }

//   $(".custom_slider").on("beforeChange", function(event, slick, currentSlide, nextSlide) {
//       var percent = (nextSlide / (slick.slideCount - 1)) * 100;
//       $(".progress-handle").css("width", percent + "%");
//   });
// });


$(document).ready(function () {

  var $slider = $('.custom_slider');
  var $track  = $('.scrubber');
  var $bar    = $('.scrubber-bar');
  var dragging = false;

  /* ---------------------------
     INIT SLICK
  ---------------------------- */
  $slider.on('init reInit breakpoint', function (event, slick) {
    updateScrubberSize(slick);
    updateScrubberPosition(slick.currentSlide, slick);
  });

  $slider.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    prevArrow: "<button type='button' class='slick-prev'><i class='fa fa-angle-left'></i></button>",
    nextArrow: "<button type='button' class='slick-next'><i class='fa fa-angle-right'></i></button>",
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 }
      },
      // Below 768px the carousel is turned off entirely and the markup falls
      // back to its own `grid--2-col`, giving a two-up product grid. Slick picks
      // the SMALLEST breakpoint above the current width, so this has to be the
      // only entry under 1024 — leaving the old 600/480 entries in place would
      // win at phone widths and keep it a carousel.
      {
        breakpoint: 768,
        settings: 'unslick'
      }
    ]
  });

  /* ---------------------------
     UPDATE SCRUBBER WIDTH
  ---------------------------- */
  function updateScrubberSize(slick) {
    // No slick instance below the unslick breakpoint.
    if (!slick || !slick.options || !$track.length) return;
    var slidesToShow = slick.options.slidesToShow;
    var totalSlides  = slick.slideCount;
    var trackWidth   = $track.width();

    var barWidth = (slidesToShow / totalSlides) * trackWidth;

    // Minimum width safeguard
    barWidth = Math.max(barWidth, 40);

    $bar.css('width', barWidth + 'px');
  }

  /* ---------------------------
     UPDATE SCRUBBER POSITION
  ---------------------------- */
  function updateScrubberPosition(slideIndex, slick) {
    var trackWidth = $track.width();
    var barWidth   = $bar.width();
    var maxSlide   = slick.slideCount - slick.options.slidesToShow;

    if (maxSlide <= 0) {
      $bar.css('left', 0);
      return;
    }

    var percent = slideIndex / maxSlide;
    var leftPos = percent * (trackWidth - barWidth);

    $bar.css('left', leftPos + 'px');
  }

  /* ---------------------------
     SLIDER CHANGE EVENT
  ---------------------------- */
  $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    updateScrubberPosition(nextSlide, slick);
  });

  /* ---------------------------
     DRAG EVENTS
  ---------------------------- */
  $bar.on('mousedown touchstart', function (e) {
    e.preventDefault();
    dragging = true;
  });

  $(document).on('mouseup touchend', function () {
    dragging = false;
  });

  $(document).on('mousemove touchmove', function (e) {
    if (!dragging) return;

    var slick = $slider.slick('getSlick');

    var trackOffset = $track.offset().left;
    var trackWidth  = $track.width();
    var barWidth    = $bar.width();

    var pageX = e.pageX || e.originalEvent.touches[0].pageX;
    var x = pageX - trackOffset - barWidth / 2;

    x = Math.max(0, Math.min(x, trackWidth - barWidth));

    $bar.css('left', x + 'px');

    var percent   = x / (trackWidth - barWidth);
    var maxSlide  = slick.slideCount - slick.options.slidesToShow;
    var targetSlide = Math.round(percent * maxSlide);

    $slider.slick('slickGoTo', targetSlide);
  });

});